import axios from 'axios';

const NOTIFICATION_CENTER_API_BASE = '/api/services/notification-center';

export const notificationCenterService = {
  /**
   * Get the unified list of notifications (order + weather + future types) for the bell/page.
   * @param {{ daysBack?: number, skip?: number, take?: number, isRead?: boolean|null, includeDismissed?: boolean, sortByMostRecent?: boolean }} options
   */
  async getNotifications({ daysBack = 20, skip = 0, take = 20, isRead = null, includeDismissed = false, sortByMostRecent = false } = {}) {
    try {
      const params = { daysBack, skip, take, includeDismissed };
      if (isRead !== null) {
        params.isRead = isRead;
      }
      if (sortByMostRecent) {
        params.sortByMostRecent = true;
      }
      const response = await axios.get(`${NOTIFICATION_CENTER_API_BASE}/notifications`, { params });
      return { success: true, data: response.data };
    } catch (err) {
      const msg = err?.response?.data?.error_description || err?.response?.data?.Message || err.message;
      console.error('notificationCenterService.getNotifications failed:', msg, err);
      return { success: false, error: msg };
    }
  },

  /**
   * Mark a single notification as read for the current user.
   * @param {number|string} notificationCenterId
   * @param {string|null} notificationType Optional notification type (e.g. 'WeatherAlert').
   */
  async markAsRead(notificationCenterId, notificationType = null) {
    try {
      const params = {};
      if (notificationType) {
        params.notificationType = notificationType;
      }
      const response = await axios.put(
        `${NOTIFICATION_CENTER_API_BASE}/notifications/${notificationCenterId}/mark-read`,
        null,
        { params }
      );
      return { success: true, data: response.data };
    } catch (err) {
      const msg = err?.response?.data?.error_description || err?.response?.data?.Message || err.message;
      console.error('notificationCenterService.markAsRead failed:', msg, err);
      return { success: false, error: msg };
    }
  }
};

export default notificationCenterService;
